<template>
    <div>
        <el-col :span="span ||4"  v-if="['prop','label'].includes(type)">
                <el-form-item :label="type+':'"
                            label-width="80px"
                            :prop="prop"
                            :rules="{required: true, message: '该项必填', trigger: 'blur'}"
                            >
                <el-input
                    v-model="cus_value"
                    size='small'
                    :placeholder="{prop:'字段，如:search',label:'名称，如:包名'}[type]"
                >
                </el-input>
            </el-form-item>

        </el-col>


        <el-col :span="span ||8"  v-if="['overProps'].includes(type)">

                <el-form-item :label="type+':'"
                            label-width="80px"
                            :prop="prop"
                            >
                <el-input
                    type="textarea"
                    v-model="cus_value"
                    size='small'
                    placeholder="覆盖el-date-picker的配置，如{placeholder:'请选择时间’,type:'datetime'}"
                >
                </el-input>
            </el-form-item>

        </el-col>


        <el-col  :span="span ||8"  v-if="['options'].includes(type)">
            <el-row>
                <el-col :span="20">
                    <el-form-item :label="type+':'"
                                    label-width="80px"
                                    :prop="prop"
                                    >
                        <el-input
                            type='textarea'
                            v-model="cus_value"
                            size='small'
                            placeholder='(下拉框/单选框等)映射配置，如{"1":"类型1","2":"类型2"}或者{key:1,value:"类型1"},记得使用英文字符！！！！！'
                        >
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="2"  v-if="config.hasOwnProperty('multiple')">
                    <el-form-item :label="'多选:'"
                                    label-width="80px"
                                    >
                        <el-checkbox
                            v-model="config['multiple']"
                            size='small'
                        >
                        </el-checkbox>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-col>
        <el-col  :span="span ||10"  v-if="['template'].includes(type)">
            <el-row>
                <el-col :span="20">
                    <el-form-item :label="type+':'"
                                    label-width="80px"
                                    :prop="prop"
                                    >
                        <el-input
                            type='textarea'
                            v-model="cus_value"
                            size='small'
                            :placeholder="`表格列template内代码，可直接使用scope，如<div>{{scope.row.name}}</div>`"
                        >
                        </el-input>
                    </el-form-item>
                </el-col>

            </el-row>
        </el-col>
        <el-col  :span="span ||8"  v-if="['ident'].includes(type)">
  
                    <el-form-item :label="type+':'"
                                    label-width="80px"
                                    :prop="prop"
                                    >
                        <el-select  
                            v-model="cus_value"
                            filterable
                            clearable
                            placeholder="请选择"
                            v-if="Object.keys(imageConfig).length>0"
                        >
                            <el-option 
                                v-for="item in Object.keys(imageConfig)"
                                :key="item"
                                :label="item"
                                :value="item">
                                
                            <span>{{item}}---{{imageConfig[item][0].type}}{{imageConfig[item][0].size}}-{{ imageConfig[item][0].width }}*{{imageConfig[item][0].height}}</span>
                            </el-option>
                        </el-select>
                        <el-input
                            v-model="cus_value"
                            size='small'
                            placeholder='图片ident,没有可不填'
                            v-else
                        >
                        </el-input>
                    </el-form-item>

            
        </el-col>


    </div>
</template>

<script>
export default {
    props:[
        'span','type','prop','value','config'
    ],
    components: {},
    data() {
        return {
            imageConfig: this.$store.state.common?this.$store.state.common.config:{},
        };
    },
    created() {},
    mounted() {},
    activited() {},
    methods: {

    },
    computed: {
        cus_value: {
            // getter
            get() {
                return this.value;
            },
            // setter
            set(newValue) {
                this.$emit('input', newValue);
            }
        } 
    },
    watch: {},
};
</script>

<style lang="scss" scoped>

</style>
